import script from "./CalendarSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./CalendarSnackbar.vue?vue&type=style&index=0&id=7b81a3b0&lang=css"

const __exports__ = script;

export default __exports__